import { DeviceEntities } from 'console/shared/content/device/types';
import { isEqual } from 'lodash';
import memoizeOne from 'memoize-one';
import { validateDeviceConfig } from 'console/shared/content/device/utils';
export function getTabConfig(device_tab_content) {
    const { heating_circuits, heating_modes, thermometers, vehicle_controls, boiler_heating_circuits, vehicle_custom_controls, boiler_heating_modes, sensors, custom_controls, guard_controls, rf_indicators, guard_zones, } = device_tab_content;
    return {
        [DeviceEntities.heating_circuits]: validateDeviceConfig(heating_circuits),
        [DeviceEntities.heating_modes]: validateDeviceConfig(heating_modes),
        [DeviceEntities.vehicle_controls]: validateDeviceConfig(vehicle_controls),
        [DeviceEntities.thermometers]: validateDeviceConfig(thermometers),
        [DeviceEntities.guard_zones]: validateDeviceConfig(guard_zones),
        [DeviceEntities.guard_controls]: validateDeviceConfig(guard_controls),
        [DeviceEntities.boiler_heating_circuits]: validateDeviceConfig(boiler_heating_circuits),
        [DeviceEntities.boiler_heating_modes]: validateDeviceConfig(boiler_heating_modes),
        [DeviceEntities.sensors]: validateDeviceConfig(sensors),
        [DeviceEntities.custom_controls]: validateDeviceConfig(custom_controls),
        [DeviceEntities.vehicle_custom_controls]: validateDeviceConfig(vehicle_custom_controls),
        [DeviceEntities.rf_indicators]: validateDeviceConfig(rf_indicators),
    };
}
export const memoizeTabContent = memoizeOne(getTabConfig, isEqual);
